import React from 'react';
import homePageContentCMS from '../../../../cms/homePage.html';
import style from './HomePageContents.less';
import { fetchCmsContent } from '../../hooks/fetchCmsContent';
import homePageBnbContentCMS from '../../../../cms/homePageBnb.html';
import { useAppSelector } from '../../store/store';
export var HomePageContents = function HomePageContents(_ref) {
  var isBranchenbuch = _ref.isBranchenbuch;
  var cmsContent = fetchCmsContent();
  var apiEndpoint = useAppSelector(function (state) {
    var _state$config;
    return (_state$config = state.config) === null || _state$config === void 0 ? void 0 : _state$config.API_ENDPOINT;
  });
  var isSandbox = apiEndpoint === null || apiEndpoint === void 0 ? void 0 : apiEndpoint.includes('tuv');
  return /*#__PURE__*/React.createElement("div", {
    className: "one-whole horizontal-center padding-l ".concat(style.contentWrapper)
  }, isSandbox && cmsContent !== '' ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: cmsContent
    }
  }) : isBranchenbuch ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: homePageBnbContentCMS
    }
  }) : /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: homePageContentCMS
    }
  }));
};